import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||122}
    height={props.width?`calc(${props.width}/373*122)`:122}
    viewBox="0 0 373 122"
    fill="none"
    style={props.style||{}}

  >
    <path
      fill="#00C9D6"
      stroke="#fff"
      strokeWidth={6}
      d="m368.526 76.49 1.328-.891V3H3v115.35h303.218l.758-.51 61.55-41.35Z"
    />
    <path
      fill="#fff"
      d="M140.785 82.269c-4.656 0-9.648-1.728-13.344-5.136l4.896-5.904c2.496 2.16 5.808 3.648 8.64 3.648 3.168 0 4.656-1.2 4.656-3.12 0-2.064-1.968-2.736-5.04-4.032l-4.56-1.92c-3.744-1.488-7.248-4.608-7.248-9.792 0-6 5.376-10.8 12.96-10.8 4.128 0 8.496 1.584 11.616 4.704l-4.272 5.376c-2.352-1.776-4.56-2.736-7.344-2.736-2.64 0-4.224 1.056-4.224 2.928 0 2.016 2.208 2.784 5.376 4.032l4.464 1.776c4.416 1.776 7.056 4.752 7.056 9.792 0 5.952-4.992 11.184-13.632 11.184Zm27.726 0c-6.864 0-9.648-4.368-9.648-10.8V60.957h-3.696V54.62l4.224-.336.96-7.248h7.056v7.248h6.432v6.672h-6.432v10.416c0 3.024 1.44 4.224 3.456 4.224.864 0 1.824-.288 2.496-.528l1.344 6.192c-1.44.432-3.408 1.008-6.192 1.008Zm16.035 0c-5.04 0-8.112-3.744-8.112-8.304 0-5.76 4.512-8.88 15.168-10.032-.192-2.208-1.344-3.504-4.128-3.504-2.16 0-4.416.864-7.152 2.4l-2.976-5.616c3.6-2.16 7.488-3.6 11.76-3.6 7.056 0 11.04 3.936 11.04 12.48v15.504h-6.96l-.576-2.736h-.24c-2.256 2.016-4.8 3.408-7.824 3.408Zm2.928-6.624c1.728 0 2.88-.816 4.128-2.16v-4.368c-5.328.672-7.056 2.256-7.056 4.176 0 1.584 1.152 2.352 2.928 2.352Zm19.27 5.952V54.285h6.96l.624 4.752h.144c2.016-3.648 5.04-5.424 7.776-5.424 1.632 0 2.544.24 3.312.576l-1.392 7.344c-1.008-.24-1.824-.432-3.024-.432-2.016 0-4.464 1.296-5.856 4.896v15.6h-8.544Zm33.017.672c-6.864 0-9.648-4.368-9.648-10.8V60.957h-3.696V54.62l4.224-.336.96-7.248h7.056v7.248h6.432v6.672h-6.432v10.416c0 3.024 1.44 4.224 3.456 4.224.864 0 1.824-.288 2.496-.528l1.344 6.192c-1.44.432-3.408 1.008-6.192 1.008Z"
    />
  </svg>
)
export default SvgComponent
